import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useUploadGalleryImageMutation } from "./galleryImagesApiSlice";
import { useGetGalleryEventsQuery } from "../galleryEvents/galleryEventsApiSlice";
import { useGetGalleryCategoriesQuery } from "../galleryCategories/galleryCategoriesApiSlice";

const NewGalleryImageForm = () => {
  const navigate = useNavigate();

  const [uploadGalleryImage, { isLoading }] =
    useUploadGalleryImageMutation();

  const { data: eventsData } = useGetGalleryEventsQuery();
  const { data: categoriesData } = useGetGalleryCategoriesQuery();

  const events = eventsData?.data || [];
  const categories = categoriesData?.data || [];

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    category: "",
    event: "",
    tags: "",
    isFeatured: false,
    order: 0,
    takenAt: "", // ✅ NEW FIELD
    image: null,
  });

  const [preview, setPreview] = useState(null);

  // ================================
  // HANDLE INPUT CHANGE
  // ================================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  // ================================
  // HANDLE IMAGE CHANGE
  // ================================
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      setPreview(URL.createObjectURL(file));
    }
  };

  // ================================
  // HANDLE SUBMIT
  // ================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      data.append("title", formData.title);
      data.append("description", formData.description);
      data.append("category", formData.category);
      data.append("event", formData.event);
      data.append("tags", formData.tags);
      data.append("isFeatured", formData.isFeatured);
      data.append("order", formData.order);

      // ✅ IMPORTANT
      if (formData.takenAt) {
        data.append("takenAt", formData.takenAt);
      }

      if (formData.image) {
        data.append("file", formData.image);
      }

      await uploadGalleryImage(data).unwrap();

      alert("Image uploaded successfully");

      navigate("/dashboard/gallery");

    } catch (error) {
      console.error(error);
      alert(error?.data?.message || "Upload failed");
    }
  };

  return (
    <div className="form-container">

      <h2>Add Gallery Image</h2>

      <form onSubmit={handleSubmit}>

        {/* TITLE */}
        <div className="form-group">
          <label>Title</label>

          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* DESCRIPTION */}
        <div className="form-group">
          <label>Description</label>

          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* CATEGORY */}
        <div className="form-group">
          <label>Category</label>

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">
              Select Category
            </option>

            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.title}
              </option>
            ))}

          </select>
        </div>

        {/* EVENT */}
        <div className="form-group">
          <label>Event</label>

          <select
            name="event"
            value={formData.event}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">
              Select Event
            </option>

            {events.map((event) => (
              <option key={event._id} value={event._id}>
                {event.title}
                {event.year
                  ? ` (${event.year})`
                  : ""}
              </option>
            ))}

          </select>
        </div>

        {/* DATE */}
        <div className="form-group">
          <label>Date</label>

          <input
            type="date"
            name="takenAt"
            value={formData.takenAt}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* TAGS */}
        <div className="form-group">
          <label>Tags</label>

          <input
            type="text"
            name="tags"
            value={formData.tags}
            onChange={handleChange}
            className="form-control"
            placeholder="comma separated"
          />
        </div>

        {/* ORDER */}
        <div className="form-group">
          <label>Order</label>

          <input
            type="number"
            name="order"
            value={formData.order}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        {/* FEATURED */}
        <div className="form-group">

          <label>

            <input
              type="checkbox"
              name="isFeatured"
              checked={formData.isFeatured}
              onChange={handleChange}
            />

            Featured

          </label>

        </div>

        {/* IMAGE */}
        <div className="form-group">
          <label>Image</label>

          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            required
          />
        </div>

        {/* PREVIEW */}
        {preview && (
          <div className="preview">
            <img
              src={preview}
              alt="preview"
              width="200"
            />
          </div>
        )}

        {/* SUBMIT */}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isLoading}
        >
          {isLoading
            ? "Uploading..."
            : "Upload Image"}
        </button>

      </form>

    </div>
  );
};

export default NewGalleryImageForm;
